import { statusStyles } from "@/mocks/site";

type StatusBadgeProps = {
  status: string;
  size?: "sm" | "md";
};

export default function StatusBadge({ status, size = "sm" }: StatusBadgeProps) {
  const style = statusStyles[status] ?? {
    label: status,
    className: "bg-foreground-700 text-background-50",
  };

  const sizeClass =
    size === "md" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[11px]";

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full font-medium tracking-wide ${sizeClass} ${style.className}`}
    >
      {style.label}
    </span>
  );
}